import React, { useRef } from 'react';
import {Button,Modal,ModalBody,ModalFooter} from "react-bootstrap"
import deleteProject from "../../../api/deleteProject"
import {useSelector} from "react-redux"
import {useHistory} from "react-router-dom"

const ConfirmModal = (props) => {
    const selectedProject = useSelector(state => state.selectedProject);

    const usernameInput = useRef();
    const passwordInput = useRef();
    const history = useHistory();

    const handleDeleteProject = async () => {
        await deleteProject(selectedProject.name, {username: usernameInput.current.value, password:  passwordInput.current.value })
        history.push("/home")
        props?.toggle();
    }
    return (
        <Modal show={props.modal}
            onHide={props?.toggle}
            backdrop="static"
            keyboard={"false"}>
            <Modal.Body className="confirmation_modal">
               <label>
                   Username
                   <input ref={usernameInput} type="text" placeholder="Enter username" />
               </label>
               <label>
                   Password
                   <input ref={passwordInput} type="password" placeholder="Enter Password" />
               </label>
            </Modal.Body>

            <Modal.Footer style={{border:"none"}}>
                <Button onClick={handleDeleteProject} variant="primary">Oui</Button>
                <Button variant="secondary" onClick={props?.toggle}>Non</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmModal;
